import React from 'react';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';
import { dateISOStringToFormat, dateToFormat } from 'utils/formatters/date';

const Formatter: React.FC<DataTypeProvider.ValueFormatterProps> = ({
  value,
}: DataTypeProvider.ValueFormatterProps) => {
  if (value && typeof value === 'string') {
    return <span>{dateISOStringToFormat(value)}</span>;
  }

  if (value && value instanceof Date) {
    return <span>{dateToFormat(value)}</span>;
  }
  return <span />;
};

export const DateTypeProvider: React.FC<DataTypeProviderProps> = (props) => (
  <DataTypeProvider formatterComponent={Formatter} {...props} />
);
